import { motion } from 'framer-motion';
import { ReactNode } from 'react';

type OnboardingStepPreviewProps = {
    active?: boolean;
    icon: ReactNode;
    title: string;
    description: string;
};

function OnboardingStepPreview({ active = false, icon, title, description }: OnboardingStepPreviewProps): JSX.Element {
    return (
        <motion.div className="flex gap-2 h-10" animate={{ opacity: active ? 1 : 0.4 }} initial={false} transition={{ duration: 0.25 }}>
            <div className="flex items-center justify-center bg-backgroundPrimary rounded-md border border-borderPrimary p-2">
                <span className="h-5 w-5 text-contentPrimary">{icon}</span>
            </div>
            <div>
                <p className="text-contentPrimary text-sm font-medium">{title}</p>
                <p className="text-contentSecondary text-sm">{description}</p>
            </div>
        </motion.div>
    );
}

export default OnboardingStepPreview;
